<template>
  <div>
    <v-expansion-panels v-if="!loading && specificFolder.length > 0">
      <v-expansion-panel
        v-for="(item, i) in specificFolder"
        :key="i"
        :readonly="item.isDocument"
      >
        <v-expansion-panel-header
          :hide-actions="item.isDocument"
          :style="`${item.isDocument ? 'cursor: default' : ''}`"
        >
          <div
            v-if="item.isDocument"
            class="d-flex justify-center"
            style="max-width: 20px; margin-top: -6px"
          >
            <v-checkbox
              class="mr-1"
              dense
              small
              v-model="item.selected"
              hide-details
              @click="addToDownloadList(item)"
            ></v-checkbox>
          </div>
          <span
            v-if="item.isDocument"
            style="margin-bottom: -4px; margin-left: 6px"
          >
            <v-icon class="pr-2" style="margin-top: -3px">
              mdi-file-document-outline
            </v-icon>
            <span class="font-weight-medium pt-2">{{ item.name }}</span>
          </span>
          <span v-else>
            <v-icon class="pr-2" style="margin-top: -3px">
              mdi-folder-outline
            </v-icon>
            <span class="font-weight-medium pt-2">{{ item.name }}</span>
          </span>
          <div
            :style="`display: flex; justify-content: flex-end; ${
              item.isDocument ? 'margin-right: 32px' : 'margin-right: 12px'
            }`"
          >
            <span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="ma-1"
                    small
                    depressed
                    color="primary"
                    @click.stop="
                      item.isDocument ? editDocument(item) : updateFolder(item)
                    "
                    v-if="institution.userType < 3 || institution.userType == 8"
                  >
                    <v-icon small color="#f5f5f5">mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-menu v-if="!item.isDocument" offset-y>
                <template v-slot:activator="{ on }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltipOn }">
                      <v-btn
                        class="ma-1"
                        small
                        depressed
                        color="primary"
                        v-on="{ ...on, ...tooltipOn }"
                        v-if="
                          institution.userType < 3 || institution.userType == 8
                        "
                      >
                        <v-icon small color="#f5f5f5">mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Adicionar</span>
                  </v-tooltip>
                </template>
                <v-list nav dense>
                  <v-list-item-group active-class="info--text text--accent-2">
                    <v-list-item
                      v-for="(actionItem, index) in addTableItems"
                      :key="index"
                      @click.stop="actionItem.action(item)"
                      width="100%"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon>{{ actionItem.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>{{
                        actionItem.title
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>

              <v-tooltip v-if="item.isDocument" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="ma-1"
                    small
                    depressed
                    color="primary"
                    @click.stop="getFile(item)"
                  >
                    <v-icon small color="#f5f5f5">mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>Abrir documento</span>
              </v-tooltip>

              <v-tooltip v-if="item.isDocument" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="item.extension === 'pdf'"
                    class="ma-1"
                    :readonly="item.validated"
                    :color="item.validated ? 'secondary' : 'primary'"
                    depressed
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="validateDoc(item)"
                    small
                  >
                    <v-icon dark> mdi-check </v-icon>
                  </v-btn>
                </template>
                <span>{{
                  item.validated ? 'Documento validado' : 'Validar documento'
                }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="ma-1"
                    small
                    depressed
                    color="#ff4f64"
                    v-if="institution.userType < 3 || institution.userType == 8"
                    @click.stop="
                      item.isDocument
                        ? deleteDocument(item)
                        : deleteFolder(item)
                    "
                  >
                    <v-icon small color="#f5f5f5">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>Excluir</span>
              </v-tooltip>
            </span>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <StandardCommonSubFolder
            v-if="!item.isDocument"
            :folder="item"
            :add-table-items="addTableItems"
            @edit-document="editDocument"
            @update-folder="updateFolder"
            @get-file="getFile"
            @validate-doc="validateDoc"
            @delete-document="deleteDocument"
            @delete-folder="deleteFolder"
            @add-to-download-list="addToDownloadList"
            @open-add-folder-modal="openAddFolderModal"
            @open-add-doc-modal="openAddDocModal"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div
      v-else-if="!loading && specificFolder.length === 0"
      class="text-center pa-4"
    >
      <span>Esta pasta está vazia</span>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import StandardCommonSubFolder from './standardCommonSubFolder.vue'

export default {
  name: 'commonFolder',
  components: { StandardCommonSubFolder },
  props: {
    folder: Object,
    index: Number,
    active: Boolean,
    addTableItems: Array,
  },
  data() {
    return {
      apiService: new ApiService(),
      specificFolder: [],
      filterListFolderWithDoc: {
        institutionId: null,
        page: 1,
        pageSize: 10,
      },
      loading: false,
      user: {},
      institution: {},
    }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.getSpecificFolder(this.folder)
  },

  watch: {
    active() {
      this.getSpecificFolder(this.folder)
    },
  },

  methods: {
    async getSpecificFolder(folder) {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id
      this.filterListFolderWithDoc.institutionId = institutionId
      this.filterListFolderWithDoc.folderId = folder.id
      this.loading = true

      try {
        const response = await this.apiService.get(
          `StandardCommonAreaDocumentFolder/list-with-doc`,
          this.filterListFolderWithDoc
        )
        this.specificFolder = response.content.data
        this.loading = false
      } catch (error) {
        this.loading = false
        console.error('Erro ao carregar dados da pasta:', error)
      }
    },

    editDocument(item) {
      this.$emit('edit-document', item)
    },

    updateFolder(item) {
      this.$emit('update-folder', item)
    },

    getFile(item) {
      this.$emit('get-file', item)
    },

    validateDoc(item) {
      this.$emit('validate-doc', item)
    },

    deleteDocument(item) {
      this.$emit('delete-document', item)
    },

    deleteFolder(item) {
      this.$emit('delete-folder', item)
    },

    addToDownloadList(item) {
      this.$emit('add-to-download-list', item)
    },

    openAddFolderModal(item) {
      this.$emit('open-add-folder-modal', item)
    },

    openAddDocModal(item) {
      this.$emit('open-add-doc-modal', item)
    },
  },
}
</script>

<style scoped>
.topper-espansion-title {
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  overflow-wrap: break-word;
  text-align: center;
}
.v-expansion-panel-header {
  padding-block: 8px !important;
}
</style>
